export const IconSuitcaseCompany20: {
  name: 'icon_suitcase_company_20-309032a73004'
} = {
  name: 'icon_suitcase_company_20-309032a73004'
}
